var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDrawPoint(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4c3 0 6 2.48 6 5.538l-.01.392C17.93 11.125 15.933 14.482 12 20l-4.252-6.238C6.268 11.537 6 10.85 6 9.538 6 6.48 9 4 12 4zm0 2.286c-1.988 0-3.6 1.535-3.6 3.428 0 1.894 1.612 3.429 3.6 3.429s3.6-1.535 3.6-3.429c0-1.893-1.612-3.428-3.6-3.428z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}
export default __webpack_public_path__ + "static/media/a68e0a6b5c6cdf734a8edc16051aa1f9-DrawPoint.svg";
export { SvgDrawPoint as ReactComponent };